// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3wPbR","spinner":"Spinner_spinner__1Neu5","load8":"Spinner_load8__1FLaS","spinnerLight":"Spinner_spinnerLight__5215F"};